export default class MetodosAuxiliares {
    constructor() {
    }

    ConferirVazioOuNulo(val) {
        if (val == null || val == undefined || val == "") {
            return true
        } 
        return false
    };
    IsLoginAdm(login) {
        console.log(login)
        if (this.ConferirVazioOuNulo(login)) {           
            throw new Error("label.preencha_login");
        } 
    };

    IsSenhaAdm(senha) {
            if (this.ConferirVazioOuNulo(senha)) {           
            throw new Error("label.preencha_senha");
        } 
    }
   
    isNumberWithDot(evt) {
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
            evt.preventDefault();;
        } else {
            return true;
        }
    };

    isNumber(evt) {
        evt = evt ? evt : window.event;
        var charCode = evt.which ? evt.which : evt.keyCode;
        if (
            charCode > 31 &&
            (charCode < 48 || charCode > 57) &&
            charCode !== 46
        ){
            evt.preventDefault();
        } else {
            return true;
        }
    };
    
    baixarPdf(base64, nome) {
        'use strict';
        const fs = require('fs');
        let buff = new Buffer(base64, 'base64');

        const blob = new Blob([buff], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = nome;
        link.click();
        URL.revokeObjectURL(link.href);
    };


    formatarCpf(cpf) {
        return cpf.replace(".","").replace(".","").replace("-","")
    };

}